export default "/images/reject.svg?0e5012fc036c07380806c15546eda6c3";